import { memo, useMemo } from 'react';
import { useAppSelector } from 'redux/hooks';
import { appCanonicalUrlSelector } from '@doda/common/src/redux/features/canonical';
import { appQueryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import { DODA_SITE_URL } from '@doda/common/src/constants/urls';
import { getOgpForJobSearchDetail } from '@doda/common/src/logics/ogp';
import type {
  JobDetailResponse,
  ScoutJobDetailResponse,
} from '@doda/api-client/aspida/@types';
import { Tag } from '@doda/common/src/components/Head/metaTag';
import { getMetaText } from '../../logics/getMetaText';
import type { Tab } from '../../types/tab';

/**
 *求人詳細Props
 */
interface Props {
  /** 求人詳細情報 */
  job: JobDetailResponse | ScoutJobDetailResponse | null;
  /** スカウト求人かどうか */
  isScout: boolean;
  /** タブの状態 */
  initialTab: Tab;
}

/**
 * MetaTagコンポーネント
 */
export const MetaTag: React.FC<Props> = memo(({ job, isScout, initialTab }) => {
  const canonicalUrl = useAppSelector(appCanonicalUrlSelector);
  const query = useAppSelector(appQueryParamsSelector);

  const meta = useMemo(() => {
    const path = DODA_SITE_URL.jobSearchDetail;
    const option = {
      corporateName: job?.job?.corporateName ?? '',
      occupationName: job?.job?.occupationName ?? '',
      locations: job?.locations ?? null,
      summaries: job?.job?.articleSummaryList ?? null,
      wcnsId: job?.job?.wcnsId ?? '',
      htmlExists: !!job?.job?.recuruitPrImage?.imageHTML,
      isPriorityDisplay: job?.job?.recuruitPrImage?.isPriorityDisplay ?? false,
    };
    const { title, keywords, description } = getMetaText(
      query,
      path,
      option,
      initialTab
    );
    const jid = job?.job?.jid ?? '';
    const ogp = getOgpForJobSearchDetail(canonicalUrl, isScout, jid);
    return { title, keywords, description, ogp };
    // TODO: 修正してdisableを取り除く
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Tag
      title={
        job
          ? meta.title
          : '転職情報ならdoda（デューダ） ｜転職ならdoda（デューダ）'
      }
      description={meta.description}
      keywords={meta.keywords}
      type={meta.ogp?.type}
      url={meta.ogp?.url}
      image={meta.ogp?.image}
      siteName={meta.ogp?.siteName}
      canonical={canonicalUrl ?? undefined}
      robots={!job ? 'noindex' : undefined}
    />
  );
});
MetaTag.displayName = 'MetaTag';
